export default __webpack_public_path__ + "static/media/020-pancake.d1e18d6f.svg";